export default "__VITE_ASSET__acf005fd__"